import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Form from 'react-bootstrap/Form';
import styles from '../CommonStyles';

const SwitchContainer = styled.div`
  display: inline-flex;
  align-items: center;

  .switch-wrapper {
    position: relative;
    display: inline-block;
    width: 44px;
    height: 26px;
  }

  .switch-input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #757575;
    border-radius: 15px;
    transition: 0.3s;
    border: 1px solid #757575;
  
  }

  .slider::before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 3px;
    top: 3px;
    background-color: #fff;
    border-radius: 50%;
    transition: 0.3s;
    border: 1px solid #757575;
    padding:inherit !important;
  }

  .switch-input:checked + .slider {
    background-color: #004a98;
    border-color: #004a98;
  }

  .switch-input:checked + .slider::before {
    transform: translateX(18px);
  }

  .switch-input:disabled + .slider {
    background-color: #9091b2;
    cursor: not-allowed;
  }

  .switch-input:disabled + .slider::before {
    background-color: #ccc;
    cursor: not-allowed;
  }

  .switch-input:focus + .slider {
    outline: 2px solid #000;
    outline-offset: 2px;
  }
`;

const WSwitch = ({
  id,
  onSwitchClick,
  errortext,
  errorstyle,
  disabled,
  checked,
  arialabelledby,
  name,
  onBlur,
  arialabel,
  ariadescribedby,
}) => {
  const isError = Boolean(errortext);

  const accessibilityProps = {
    ...(arialabelledby && { 'aria-labelledby': arialabelledby }),
    ...(arialabel && { 'aria-label': arialabel }),
    ...(ariadescribedby && { 'aria-describedby': ariadescribedby }),
  };

  const formTextStyles = { ...styles.errorStyle, ...errorstyle }

  return (
    <SwitchContainer onClick={e => e.stopPropagation()}>
      <label className="switch-wrapper">
        <input
          type="checkbox"
          id={id}
          name={name}
          checked={checked}
          disabled={disabled}
          onChange={onSwitchClick}
          onBlur={onBlur}
          className="switch-input"
          {...accessibilityProps}
        />
        <span className="slider"></span>
      </label>

      {isError && (
        <Form.Text
          style={formTextStyles}
          role="region"
          id={`${id}inputErrorText`}
          aria-labelledby={`${id}inputErrorText`}
          aria-live="polite"
        >
          {errortext}
        </Form.Text>
      )}
    </SwitchContainer>
  );
};

WSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  onSwitchClick: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  arialabelledby: PropTypes.string,
  name: PropTypes.string,
  errortext: PropTypes.string,
  errorstyle: PropTypes.instanceOf(Object),
  onBlur: PropTypes.func,
  arialabel: PropTypes.string,
  ariadescribedby: PropTypes.string,
};

WSwitch.defaultProps = {
  label: '',
  onSwitchClick: () => {},
  disabled: false,
  checked: false,
  arialabelledby: '',
  name: '',
  errortext: '',
  errorstyle: {},
  onBlur: () => {},
  arialabel: '',
  ariadescribedby: '',
};

export default WSwitch;
